import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Shows() {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/shows`)
      .then(r => setShows(r.data))
      .catch(() => setShows([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="w-full flex flex-col items-center text-center fade-up">
      <div className="text-[10px] font-mono-r tracking-[0.5em] uppercase opacity-70">
        ::  Residents & Guests  ::
      </div>
      <h1 className="font-display text-6xl md:text-8xl mt-4">SHOWS</h1>
      <p className="font-mono-r text-xs md:text-sm tracking-[0.25em] uppercase opacity-70 mt-3">
        The voices behind the static
      </p>

      <div className="ascii-divider my-10">─  ─  ─  ─  ─</div>

      {loading && <div className="font-mono-r text-xs opacity-70">Loading shows…</div>}

      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
        {shows.map((s, i) => (
          <article
            key={s.id}
            data-testid={`show-card-${s.id}`}
            className="hairline p-6 text-left hover:bg-white hover:text-black transition-colors duration-300 group"
          >
            <div className="flex items-baseline justify-between">
              <span className="font-mono-r text-[10px] tracking-[0.4em] uppercase opacity-70 group-hover:opacity-100">
                {String(i + 1).padStart(2, '0')} / {String(shows.length).padStart(2, '0')}
              </span>
              <span className="font-mono-r text-[10px] tracking-[0.3em] uppercase">{s.time}</span>
            </div>
            <h3 className="font-display text-4xl mt-4">{s.name}</h3>
            <div className="font-mono-r text-xs tracking-[0.2em] uppercase mt-2 opacity-80 group-hover:opacity-100">
              with {s.host} · {s.day}
            </div>
            <p className="font-mono-r text-sm mt-4 leading-relaxed opacity-90 group-hover:opacity-100">
              {s.description}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
